export function resolveKycDisplay(summary, t) {
  const status = summary?.verification_status || 'unverified';
  if (status === 'verified') {
    return {
      status: 'verified',
      text: t('account.profile.verification.verified'),
      tone: 'positive',
      canSubmit: false,
      actionLabel: null,
    };
  }
  if (status === 'pending' && summary?.kyc_submitted_at) {
    return {
      status: 'pending',
      text: t('account.profile.verification.pending'),
      tone: 'pending',
      canSubmit: false,
      actionLabel: null,
    };
  }
  return {
    status: 'unverified',
    text: t('account.profile.verification.basic'),
    tone: 'warning',
    canSubmit: true,
    actionLabel: t('account.profile.verify'),
  };
}

export function phoneActionLabel(phonePresent, phoneVerified, t) {
  if (!phonePresent) return t('account.profile.add');
  if (!phoneVerified) return t('account.profile.verify');
  return t('account.profile.change');
}

export function emailActionLabel(emailPresent, emailVerified, t) {
  return phoneActionLabel(emailPresent, emailVerified, t);
}
